import { Injectable } from '@angular/core';
import { MachineAlarm } from '@shared/entities/machineAlarm';
import { ApiService } from '@shared/services';
import { BehaviorSubject, Observable, Subject, map, shareReplay, switchMap, take, tap } from 'rxjs';

const LOG_PREFIX = '[Api][MachineAlarms] ';

export interface MachineAlarmFilterURL {
  serialNumber?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MachineAlarmsService extends ApiService<MachineAlarm> {
  private refresh$: Subject<boolean>;
  all$: Observable<[string]>;
  currentFilters: MachineAlarmFilterURL = {};

  set filters(value: MachineAlarmFilterURL) {
    this.currentFilters = value;
    this.refresh(true);
  }

  constructor() {
    const masterUrl = '/machines/alarms';
    const detailUrl = '/machines/alarms';

    super(MachineAlarm, masterUrl, detailUrl, undefined, undefined);

    this.refresh$ = new BehaviorSubject<boolean>(true);

    this.all$ = this.refresh$.pipe(
      switchMap(() => {
        if (this.currentFilters.serialNumber) {
          this.setUrlParameter('serialNumber', this.currentFilters.serialNumber);
        }
        return this.findOne('');
      }),
      map((data) => {
        return data.items;
      }),
      tap({
        next: (result) => this.logger.debug(LOG_PREFIX + 'all$', result),
        error: (err) => this.logger.error(LOG_PREFIX + 'all$ error', err)
      }),
      shareReplay(1)
    );
  }

  refresh(value: boolean) {
    this.logger.debug(LOG_PREFIX + 'refresh');
    this.refresh$.next(value);

    return this.all$.pipe(take(1));
  }
}
